var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-8 flex justify-center content-center"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})])
}]

export { render, staticRenderFns }